// import Vue from 'vue';
// import Vuex from 'vuex';

// Vue.use(Vuex);

// initial state
const state = {
  // userToken: null
  userToken: localStorage.getItem('auth-token') || ''
}

// getters
const getters = {
  getUserToken: (state) => {
    // console.log("start_getters: getUserToken");
    // console.log("current state : ");
    console.log(state);
    // console.log("end_getters: getUserToken");
    return state.userToken;
  },
  getUserId: (state) => {
    var decryptedToken = JSON.parse(atob(state.userToken.split('.')[1]));
    // console.log(decryptedToken);
    return decryptedToken.nameid;
  },
  isAuthenticated: (state) => {
    // console.log("start_getters : isAuthenticated");
    var userToken = state.userToken;
    // console.log("token : " + userToken);
    if(userToken == '' || userToken == null){
      // console.log("user not logged in");
      return false;
    }

    

    // console.log("user logged in");
    return true;
  }
};

// actions
const actions = {
  checkUserToken({ commit, dispatch, state }) {
    var userToken = state.userToken;
    // We must also check the validity of the token
    var jsonTokenContent = JSON.parse(atob(userToken.split('.')[1]));
    if(jsonTokenContent.exp * 1000 < Date.now()){
      // Token expired
      console.log("token expired");
      commit('removeUserToken');
    }else{
      // console.log("token is valid");
      // console.log(actions);
      // commit('removeUserToken');
    }
  },
  logUser({commit, dispatch, state}, userToken){
    // console.log("start_actions: logUser");
    // console.log("current state : ");
    // console.log(state);
    // console.log("commit: setUserToken : " + userToken );
    commit('setUserToken', userToken);
    // localStorage.setItem('auth-token', userToken);
    // dispatch('userRequest', null, { root: true });
    // console.log("end_actions: logUser");
  },
  logOut({commit}){
    // console.log("start_actions: logOut");
    commit('removeUserToken');
    // console.log("end_actions: logOut");
  }
}

// mutations
const mutations = {
  setUserToken (state, userToken){
    console.log("start_mutations : setUserToken");
    console.log("current state : ");
    console.log(state);
    console.log("userToken : " + userToken);
    localStorage.setItem('auth-token', userToken);
    state.userToken = userToken;
    console.log("state has been modified");
    console.log("current state : ");
    console.log(state);
    console.log("end_mutations : setUserToken");
  },
  removeUserToken (state){
    console.log("start_mutations : removeUserToken");
    console.log("current state : ");
    console.log(state);
    localStorage.removeItem('auth-token');
    state.userToken = '';
    console.log("state has been modified");
    console.log("current state : ");
    console.log(state);
    console.log("end_mutations : removeUserToken");
  }
}

// export default new Vuex.Store({
export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js